import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import './index.css'
import App from './App.tsx'
import { ThemeProvider, CartProvider, CookieConsentProvider } from './context'
import { store } from './store'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <CookieConsentProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </CookieConsentProvider>
      </ThemeProvider>
    </Provider>
  </StrictMode>,
)
